import React, {useContext, useEffect, useState} from 'react';
import {Box, makeStyles} from "@material-ui/core";

import assets from "../../../helpers/assets";
import Colors from "../../../helpers/Colors";
import {AppContext} from "../../../contexts/AppContext";
import Text from "../Text";

export function CubbyAssignButton({order}) {
    const [isCubbyAssignRequested, setIsCubbyAssignRequested] = useState(false);
    const [onHover, setHover] = useState(false);

    const {setCubbyProcessOrder, cubbyProcessSuccessOrder, setCubbyProcessSuccessOrder} = useContext(AppContext);
    const classes = useStyles();

    useEffect(() => {
        if (cubbyProcessSuccessOrder?.id === order.id) {
            setIsCubbyAssignRequested(true);
            setCubbyProcessOrder(null);
            setCubbyProcessSuccessOrder(null);
        }
    }, [cubbyProcessSuccessOrder]);

    return (
        <Box
            onMouseEnter={() => {
                if (!isCubbyAssignRequested) {
                    setHover(true);
                }
            }}
            onMouseLeave={() => setHover(false)}
            onClick={() => {
                if (isCubbyAssignRequested) {
                    return;
                }
                setCubbyProcessOrder(order);
            }}
            className={isCubbyAssignRequested ? classes.disabledButtonContentContainer : classes.buttonContentContainer}
        >
            <img
                src={isCubbyAssignRequested ? assets.tick.default : assets.dispatch.default}
                alt="assign button"
                className={classes.dispatchIcon}
            />
            {onHover && (
                <Text className={classes.dispatchButtonLabel}>{isCubbyAssignRequested ? 'ASSIGN..' : 'ASSIGN'}</Text>
            )}
        </Box>
    );
}

const useStyles = makeStyles(() => ({
    dispatchIcon: {
        height: 32,
        width: 32,
        objectFit: 'contain',
    },
    dispatchButtonLabel: {
        marginLeft: 20,
        color: Colors.white,
        fontSize: 18,
        fontFamily: 'DINNextLTPro-Regular',
    },
    buttonContentContainer: {
        cursor: 'pointer',
        minHeight: 40,
        maxHeight: 40,
        paddingLeft: 15,
        paddingRight: 15,
        backgroundColor: Colors.boldBlue,
        borderRadius: 4,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    disabledButtonContentContainer: {
        cursor: 'default',
        minHeight: 40,
        maxHeight: 40,
        paddingLeft: 15,
        paddingRight: 15,
        backgroundColor: 'rgba(25, 136, 252, 0.3)',
        borderRadius: 4,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center'
    },
}));